import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
export default {
  name: 'CoreVirtualDeviceSmartGroupStatisticsCard',
  props: {
    id: {
      type: Number,
      required: true
    },
    last24Hours: {
      type: [Number, String],
      default: 0
    },
    prior24Hours: {
      type: [Number, String],
      default: 0
    },
    devices: {
      type: [Number, String],
      default: 0
    },
    errors: {
      type: [Number, String],
      default: 0
    },
    warnings: {
      type: [Number, String],
      default: 0
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      items: [1]
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['color', 'inpOutlined', 'inpFilled'])), {}, {
    canEdit: function canEdit() {
      return this.actions.includes('edit');
    },
    canDelete: function canDelete() {
      return this.actions.includes('delete');
    }
  }),
  watch: {},
  methods: {
    handleDelete: function handleDelete(event) {
      event.target.blur();
      this.$emit('delete', this.id);
    },
    handleEdit: function handleEdit(event) {
      event.target.blur();
      this.$emit('edit', this.id);
    }
  }
};